var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveswitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 17,
    viewBox: "0 0 29 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.921875,
    y: 0.172668,
    width: 27.7313,
    height: 16.2563,
    rx: 8.12813,
    fill: "#CFCFCF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.11496,
    cy: 8.30082,
    r: 7.17942,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveswitch);
export default __webpack_public_path__ + "static/media/inactiveswitch.4830bb5baffa26c723615c7987cebdb8.svg";
export { ForwardRef as ReactComponent };